/* ============================================================
   KINUJO Silk drop series LP - JS
   ------------------------------------------------------------
   依存：
   - Swiper 11（swiper-bundle.min.js を先に読み込む。無ければスライダーは
     静的な1枚表示のまま動く）
   - サイト共通の固定ヘッダー `header.header`（フォールバック `.header`）。
     テーマ側でクラス名が変わると --feat-tab-top が CSS のフォールバック値
     （base.css）に落ち、hair_oil_10 のタブ帯と hair_oil_3 のカードの
     sticky 位置がずれる。→ HEADER_SELECTORS を直す。

   機能：
   0) hair_oil_10 タブ帯 / hair_oil_3 カードの sticky オフセット（固定ヘッダー高さ＋余白）を --feat-stick-top へ
   1) FV 4状態切替（2秒自動再生。タブ非表示・画面外・reduced-motion で停止）
      ＋ FV タブの登場アニメ（読み込み直後に下から順に浮き上がる）
   2) スクロールフェードイン（下から上）。見出し・本文・購入ボタン
   3) Swiper（Stylist / Influencer。3秒自動送り。reduced-motion 時は自動再生オフ）
      ＋ Stylist キャプションの高さを全員分の最大値にそろえる（切替で下のページがずれないように）
   4) hair_oil_10 point カード：SP のみ横スクロールスライダー化（矢印＋3秒自動送り）
   5) （撤去）hair_oil_3 商品カードのピン留め演出。PC/SP とも CSS の
      position:sticky（sec03-products.css）に置き換え、JS の座標手計算は無くした
   6) hair_oil_10 Styling ギャラリー演出（パララックス＋ズーム＋ワイプ）
   7) hair_oil_14 FAQ タブ切替
   8) hair_oil_10 VIEW MORE 開閉
   9) hair_oil_7 商品詳細アコーディオンの閉じアニメ

   reduced-motion（prefers-reduced-motion: reduce）時：
     FV 自動切替・Swiper 自動送り・point 自動送りは起動しない。
     Styling ギャラリーは層だけ作り、最終状態（移動なし・等倍・マスクなし）のまま動かさない。
     フェードイン／sticky／背景固定は CSS 側（base.css / sec03 / sec10）で無効化。
   ============================================================ */
(function () {
  'use strict';

  var HEADER_SELECTORS = ['header.header', '.header'];
  var SP_QUERY = '(max-width: 959px)';
  var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var AUTOPLAY_DELAY = 3000; // Figma 注記6「3秒自動切替」（Review / point スライダー共通）

  document.addEventListener('DOMContentLoaded', function () {

    // ------------------------------------------------------------
    // 0) タブ帯・カードの固定オフセット = 固定ヘッダー高さ
    //    position:fixed のサイトヘッダー下に sticky 要素が溜まるようにする
    // ------------------------------------------------------------
    (function () {
      var findHeader = function () {
        for (var i = 0; i < HEADER_SELECTORS.length; i++) {
          var el = document.querySelector(HEADER_SELECTORS[i]);
          if (el) { return el; }
        }
        return null;
      };
      // 貼り付き位置 = 今のヘッダー高さ + gap（CSS の --feat-stick-gap。PC 23px / SP 29px）。
      // 本番テーマのヘッダーはスクロールすると縮む（header--short。PC 120→60px・SP 86→57px、背景あり）。
      // 貼り付きが起きるのは縮んだ後だけなので、縮んだヘッダーの下端から gap 空けた位置になる。
      // 読み込み時に1回だけ測ると、途中位置で読み込んだとき（アンカー付き URL・再読み込み）に
      // 縮んだ高さが基準になりヘッダーの裏へ潜った（10/7 本番で発覚）ため、高さが変わるたびに測り直す。
      var root = document.documentElement;
      var setTabTop = function () {
        var hdr = findHeader();
        var h = 0;
        if (hdr) {
          var cs = getComputedStyle(hdr);
          if (cs.position === 'fixed' || cs.position === 'sticky') {
            h = Math.round(hdr.getBoundingClientRect().height);
          }
        }
        root.style.setProperty('--feat-tab-top', h + 'px');
        var gap = parseFloat(getComputedStyle(root).getPropertyValue('--feat-stick-gap')) || 0;
        var next = (h > 0 ? h + gap : 0) + 'px';
        if (root.style.getPropertyValue('--feat-stick-top') === next) { return; }
        root.style.setProperty('--feat-stick-top', next);
        // 0b) の hair_oil_10 はこの値で面の位置を測るので、変わったら測り直させる
        window.dispatchEvent(new Event('silkdrop:stick-top'));
      };
      setTabTop();
      window.addEventListener('resize', setTabTop);
      window.addEventListener('load', setTabTop);
      var hdr = findHeader();
      if (hdr && window.ResizeObserver) { new ResizeObserver(setTabTop).observe(hdr); }
    })();

    // ------------------------------------------------------------
    // 0b) hair_oil_10 カードスタック（面は留まり、中身だけが面の中で動く）
    //     .feat-block__box を走路にして高さを与え、その中の .feat-block__stage を
    //     タブ帯の直下に sticky で固定する。走路をスクロールした量をそのまま
    //     中身の移動量（--inner-y）に変換するため、ページのスクロールバーは1本のまま。
    //     入れ子スクロールを作らないので iOS でも素直に動く。
    //     面の高さは固定なので、中身（面の子要素）を ResizeObserver で監視し、
    //     VIEW MORE 開閉で走路（--track-h）を測り直す。
    //     不透明帯は、スタックが画面上端に達し、かつどれかの面が解放された後だけ表示する（.is-band-stuck）。
    //     解放前は隠す中身が無く、出すと見出しから続く光粒背景の上に地色の帯が見えるため。
    // ------------------------------------------------------------
    // 面の中身の位置（--inner-y）を今のスクロール位置に合わせる関数。6) の Styling ギャラリーが、
    // 自分の rAF で写真の位置を読む直前に呼ぶ（同じフレームで --inner-y 更新前の古い位置を読まないため）。
    var syncInnerY = null;
    (function () {
      if (reducedMotion) { return; }
      var section = document.querySelector('.hair_oil_10');
      var stack = document.querySelector('.hair_oil_10 .feat-stack');
      var boxes = document.querySelectorAll('.hair_oil_10 .feat-stack .feat-block__box');
      var tab = document.querySelector('.hair_oil_10 .feat-block__tab');
      if (!section || !stack || !tab || boxes.length === 0) { return; }
      var cards = [];
      for (var i = 0; i < boxes.length; i++) {
        var stage = boxes[i].querySelector('.feat-block__stage');
        if (!stage) { return; }
        cards.push({ box: boxes[i], stage: stage, max: 0 });
      }
      var stageTop = 0;
      var stageH = 0;
      // 中身の下端（面の padding 込み）から面の内寸を引く。offsetTop/offsetHeight は transform の影響を受けないので、
      // --inner-y で中身を動かしている最中でも、class を付け外しせずに測れる。
      var contentMax = function (c) {
        var last = c.stage.lastElementChild;
        if (!last) { return 0; }
        var bottom = last.offsetTop + last.offsetHeight
          + (parseFloat(getComputedStyle(last).marginBottom) || 0)
          + (parseFloat(getComputedStyle(c.stage).paddingBottom) || 0);
        return Math.max(0, Math.ceil(bottom - c.stage.clientHeight));
      };
      var refresh = function () {
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          c.max = contentMax(c);
          c.box.style.setProperty('--track-h', (stageH + c.max) + 'px');
        }
        update();
      };
      var measure = function () {
        section.classList.remove('is-pin-stack');
        section.classList.remove('is-band-stuck');
        var tabTop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--feat-stick-top')) || 0;
        stageTop = Math.round(tabTop + tab.getBoundingClientRect().height);
        stageH = Math.max(240, window.innerHeight - stageTop);
        section.style.setProperty('--tab-h', Math.round(tab.getBoundingClientRect().height) + 'px');
        section.style.setProperty('--stage-top', stageTop + 'px');
        section.style.setProperty('--stage-h', stageH + 'px');
        section.classList.add('is-pin-stack');
        refresh();
      };
      var update = function () {
        // 帯は、面が解放されて中身がタブ列・透明ヘッダーの裏を通るときだけ必要。
        // 解放前に出すと、見出しから続く光粒背景の上に地色の帯が見えてしまう。
        var released = false;
        for (var r = 0; r < cards.length; r++) {
          if (cards[r].box.getBoundingClientRect().bottom < stageTop + stageH - 1) { released = true; break; }
        }
        section.classList.toggle('is-band-stuck', stack.getBoundingClientRect().top <= 0 && released);
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var y = stageTop - c.box.getBoundingClientRect().top;
          if (y < 0) { y = 0; } else if (y > c.max) { y = c.max; }
          c.stage.style.setProperty('--inner-y', Math.round(y) + 'px');
        }
      };
      var ticking = false;
      var onScroll = function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      };
      syncInnerY = update;
      measure();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      window.addEventListener('silkdrop:stick-top', measure);
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(measure);
        for (var j = 0; j < cards.length; j++) { ro.observe(cards[j].stage); }
        var contentRo = new ResizeObserver(refresh);
        for (var j = 0; j < cards.length; j++) {
          var children = cards[j].stage.children;
          for (var k = 0; k < children.length; k++) { contentRo.observe(children[k]); }
        }
      }
    })();

    // ------------------------------------------------------------
    // 1) FV 4状態切替（2秒自動再生）
    //    状態：0=ラインナップ(ポディウム/タブ非アクティブ)、1=milk、2=oil、3=multi
    //    各状態は <picture class="fv-slide" data-fv="N">（PC/SP は <source media> で出し分け）
    // ------------------------------------------------------------
    (function () {
      var fvSection = document.querySelector('.hair_oil_1');
      var fvTabs = document.querySelectorAll('.hair_oil_1 .fv-tabs .tab');
      var fvSlides = document.querySelectorAll('.hair_oil_1 .fv-kv .fv-slide');
      if (!fvSection || fvSlides.length === 0) { return; }

      var slideCount = 4;
      var activeIdx = 0;
      var setActive = function (idx) {
        fvSlides.forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.fv, 10) === idx);
        });
        // 1枚目(ポディウム)はタブ非アクティブ。2枚目以降を milk/oil/multi に対応
        fvTabs.forEach(function (t, i) {
          var on = i === idx - 1;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      };

      // 自動切替：タブ非表示（visibilitychange）・FVが画面外（IntersectionObserver）・
      // reduced-motion のときは回さない
      var autoTimer = null;
      var inView = true;
      var stopTimer = function () {
        if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      };
      var startTimer = function () {
        stopTimer();
        if (reducedMotion || document.hidden || !inView) { return; }
        autoTimer = setInterval(function () {
          activeIdx = (activeIdx + 1) % slideCount;
          setActive(activeIdx);
        }, 2000);
      };

      setActive(0);
      startTimer();

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stopTimer(); } else { startTimer(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) { startTimer(); } else { stopTimer(); }
        }, { threshold: 0 }).observe(fvSection);
      }

      // 手動クリックで対応スライドへ切替。クリック後もタイマーをリセットして自動切替を継続
      fvTabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          activeIdx = i + 1;
          setActive(activeIdx);
          startTimer();
        });
      });

      // FV タブの登場アニメ（Figma 注記3「ボタン：下から上にふわっと表示」、参考 kinujo.jp/products_2way/）
      // li 単位で .sd-fade-init を付け、次フレームで .sd-fade-in。120ms ずつ段差。
      // reduced-motion 時は base.css 側で opacity:1 / transition:none になるので何もしない
      if (!reducedMotion) {
        var tabItems = [].slice.call(document.querySelectorAll('.hair_oil_1 .fv-tabs > li'));
        tabItems.forEach(function (li, i) {
          li.style.setProperty('--sd-delay', (0.25 + i * 0.12).toFixed(2) + 's');
          li.classList.add('sd-fade-init');
        });
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            tabItems.forEach(function (li) { li.classList.add('sd-fade-in'); });
          });
        });
      }
    })();

    // ------------------------------------------------------------
    // 2) スクロールフェードイン（下から上）
    //    Figma 注記2「表示時は下から上へフェードイン」／注記3「ボタンはふわっと」。
    //    見出しブロック・本文ブロック・購入系ボタンを対象にする。
    //    ※ 注意：
    //      - .hair_oil_3 .prod-card 本体には付けない（sticky スタックの見た目が
    //        transition の過渡値で崩れる）。カード内の「詳細を見る」ボタンのみ対象
    //      - .sd-bgfix（背景固定）の要素本体には付けない（transform で fixed が壊れる）
    //      - 同じブロック内で親子両方を対象にする場合は子に遅延を持たせる
    // ------------------------------------------------------------
    if ('IntersectionObserver' in window) {
      var fadeSelectors = [
        // [セレクタ, 遅延秒（省略時 0）]
        ['.hair_oil_2 .concept-inner'],
        ['.hair_oil_3 .lead'],
        ['.hair_oil_3 .prod-card__btn', 0.15],
        ['.hair_oil_4 .cv-btn'],
        ['.hair_oil_5 .banner-inner'],
        ['.hair_oil_6 .rv-heading'],
        ['.hair_oil_6 .stylist-card'],
        ['.hair_oil_6 .stylist-slider'],
        ['.hair_oil_6 .influencer-block'],
        ['.hair_oil_7 .giftset__card'],
        ['.hair_oil_7 .indi-card'],
        ['.hair_oil_8 .frag-header'],
        ['.hair_oil_8 .frag-block__photos'],
        ['.hair_oil_8 .frag-block__inner', 0.12],
        ['.hair_oil_9 .htu-head'],
        ['.hair_oil_9 .care-block'],
        ['.hair_oil_9 .total-care'],
        ['.hair_oil_10 .feat-head__title'],
        ['.hair_oil_10 .feat-head__sub', 0.1],
        ['.hair_oil_10 .feat-block__cta'],
        ['.hair_oil_10 .styling__title'],
        ['.hair_oil_10 .care__title'],
        ['.hair_oil_11 .giftset__card'],
        ['.hair_oil_12 .cmp'],
        ['.hair_oil_13 .gbanner'],
        ['.hair_oil_14 .faq__title'],
        ['.hair_oil_14 .faq__tabs', 0.1],
        ['.hair_oil_14 .faq__panel', 0.2],
        ['.hair_oil_15 .shop__pic'],
        ['.hair_oil_15 .shop__panel'],
        ['.hair_oil_15 .shop__cta', 0.25]
      ];
      var fadeTargets = [];
      fadeSelectors.forEach(function (def) {
        document.querySelectorAll(def[0]).forEach(function (el) {
          if (el.classList.contains('sd-fade-init')) { return; }
          // display:contents（例: SP の .frag-block__inner）は箱を持たず IO が発火しないので対象外
          if (getComputedStyle(el).display === 'contents') { return; }
          if (def[1]) { el.style.setProperty('--sd-delay', def[1] + 's'); }
          el.classList.add('sd-fade-init');
          fadeTargets.push(el);
        });
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sd-fade-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      fadeTargets.forEach(function (el) { io.observe(el); });

      // ページ内リンク（hair_oil_3「詳細を見る」→ #item-milk 等）の飛び先がフェード前だと、
      // 下にずれた位置（translateY）を基準にスクロールし、フェード完了後にヘッダーの下へ潜り込む。
      // クリック時に飛び先の演出を即完了させ（transition なし）、確定した位置へ既定のアンカー移動をさせる
      document.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
        if (!a) { return; }
        var id = a.getAttribute('href').slice(1);
        var target = id && document.getElementById(id);
        if (!target || !target.classList.contains('sd-fade-init') || target.classList.contains('sd-fade-in')) { return; }
        target.style.transition = 'none';
        target.classList.add('sd-fade-in');
        io.unobserve(target);
        void target.offsetHeight;
        target.style.transition = '';
      });
    }

    // ------------------------------------------------------------
    // 3) Swiper 初期化（Stylist / Influencer）
    //    4枚のスライドでは Swiper 11 の loop（並べ替え方式）が片側にしか
    //    スライドを置けず「Loop Warning」＋片側が空になる（loopAdditionalSlides
    //    0/1/2 で実測済み）。そのため初期化前に DOM を複製して8枚にする。
    //    ※ 複製後に data-* を読むので stylistData は8件（realIndex 0〜7）で問題ない。
    //    ※ alt / aria-label 付きの要素も倍増する（動画差し替え時に見直す）。
    // ------------------------------------------------------------
    if (typeof Swiper !== 'undefined') {
      var ensureLoopSlides = function (swEl) {
        var wrap = swEl.querySelector('.swiper-wrapper');
        if (!wrap) return;
        var kids = [].slice.call(wrap.children);
        if (kids.length && kids.length < 6) {
          kids.forEach(function (s) { wrap.appendChild(s.cloneNode(true)); });
        }
      };
      // Figma 注記6：3秒自動切替。reduced-motion 時は自動送りなし
      var autoplay = reducedMotion ? false : {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
      // Stylist: coverflow + centeredSlides（常に中央＋左右2枚の3枚表示）
      var stylistEl = document.querySelector('.hair_oil_6 .stylist-slider.swiper');
      if (stylistEl) {
        ensureLoopSlides(stylistEl);
        var capBox   = document.querySelector('.hair_oil_6 .stylist-slider__caption');
        var capName  = document.querySelector('.hair_oil_6 .stylist-slider__caption-name');
        var capTitle = document.querySelector('.hair_oil_6 .stylist-slider__caption-title');
        var capDesc  = document.querySelector('.hair_oil_6 .stylist-slider__caption-desc');
        // 複製後の全スライド（8件）の data-* を realIndex で参照する
        var stylistData = [].map.call(stylistEl.querySelectorAll('.swiper-slide'), function (s) {
          return { name: s.dataset.name, prod: s.dataset.prod, title: s.dataset.title, desc: s.dataset.desc };
        });
        // キャプションへの文言の流し込み（表示用と高さ計測用の複製で同じ書き方にする）
        var fillStylistCap = function (nameEl, titleEl, descEl, d) {
          if (nameEl)  nameEl.innerHTML  = d.name + '<span class="prod">' + d.prod + '</span>';
          if (titleEl) titleEl.textContent = d.title;
          if (descEl)  descEl.textContent  = d.desc;
        };
        var updateStylistCap = function (sw) {
          var d = stylistData[sw.realIndex];
          if (!d || !d.name) return;
          fillStylistCap(capName, capTitle, capDesc, d);
        };
        var stylistSwiper = new Swiper(stylistEl, {
          effect: 'coverflow',
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: true,
          grabCursor: true,
          speed: 700,
          coverflowEffect: {
            rotate: 0,
            stretch: 44,
            depth: 0,
            scale: 0.664,
            modifier: 1,
            slideShadows: false
          },
          breakpoints: {
            0: { coverflowEffect: { scale: 0.776 } },
            960: { coverflowEffect: { scale: 0.664 } }
          },
          autoplay: autoplay,
          on: {
            slideChange: function () { updateStylistCap(this); }
          }
        });
        // loop + centered の初期位置ずれを補正し、先頭(ayaka)を中央に
        stylistSwiper.slideToLoop(0, 0);
        updateStylistCap(stylistSwiper);

        // キャプション（白ボックス）の高さを全員分の最大値にそろえる（min-height）。
        // 文言の行数で高さが変わると、切り替わるたびにキャプションより下のページ全体が上下にずれ、
        // scroll anchoring の無い iOS Safari では「放置していると画面が勝手にスクロールする」ように見える。
        // 測り方：表示中のキャプションを複製し、同じ親の中に見えない絶対配置・実物と同じ幅で置き、
        // 各人の文言を流し込んで高さを測る。最大値を実物の min-height にして、複製は外す。
        // 中身は上揃えのまま（余白は下に出る）。自動再生の有無に関係なく常に適用する。
        // 測り直し：初期化時・フォント読み込み後・load・画面幅の変化
        // （高さだけの resize ＝ iOS のアドレスバー伸縮では幅が変わらないので測り直さない）。
        if (capBox && capBox.parentNode) {
          var capUnique = [];
          var capSeen = {};
          stylistData.forEach(function (d) {
            if (!d.name) return;
            var key = [d.name, d.prod, d.title, d.desc].join('\n');
            if (capSeen[key]) return;
            capSeen[key] = true;
            capUnique.push(d);
          });
          var capViewW = -1;
          var capW = -1;
          var capMaxH = 0;
          var measureStylistCap = function () {
            var width = capBox.getBoundingClientRect().width;
            capViewW = window.innerWidth;
            capW = width;
            if (!width || capUnique.length === 0) return;
            var cs = getComputedStyle(capBox);
            var borderBox = cs.boxSizing === 'border-box';
            var edgeX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) +
                        parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
            var edgeY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) +
                        parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
            var probe = capBox.cloneNode(true);
            probe.setAttribute('aria-hidden', 'true');
            // インラインの min-height は複製しない（cssText で丸ごと置き換える）
            probe.style.cssText = 'visibility:hidden;position:absolute;pointer-events:none;' +
              'left:0;top:0;right:auto;bottom:auto;margin:0;max-width:none;' +
              'width:' + (borderBox ? width : width - edgeX) + 'px;';
            var pName  = probe.querySelector('.stylist-slider__caption-name');
            var pTitle = probe.querySelector('.stylist-slider__caption-title');
            var pDesc  = probe.querySelector('.stylist-slider__caption-desc');
            capBox.parentNode.insertBefore(probe, capBox.nextSibling);
            var maxH = 0;
            for (var i = 0; i < capUnique.length; i++) {
              fillStylistCap(pName, pTitle, pDesc, capUnique[i]);
              var h = probe.getBoundingClientRect().height;
              if (h > maxH) maxH = h;
            }
            probe.parentNode.removeChild(probe);
            capMaxH = maxH;
            var minH = (borderBox ? maxH : maxH - edgeY) + 'px';
            if (capBox.style.minHeight !== minH) { capBox.style.minHeight = minH; }
          };
          measureStylistCap();
          if (document.fonts) {
            if (document.fonts.ready) { document.fonts.ready.then(measureStylistCap); }
            if (document.fonts.addEventListener) { document.fonts.addEventListener('loadingdone', measureStylistCap); }
          }
          window.addEventListener('load', measureStylistCap);
          var capResizeQueued = false;
          window.addEventListener('resize', function () {
            if (capResizeQueued) return;
            capResizeQueued = true;
            window.requestAnimationFrame(function () {
              capResizeQueued = false;
              if (window.innerWidth !== capViewW || capBox.getBoundingClientRect().width !== capW) {
                measureStylistCap();
              }
            });
          });
          // 取りこぼし対策：実物の幅が変わった（CSS の適用が遅れた等）、または高さが測った最大値を超えた
          // （フォントの読み込み完了を上のどれでも拾えず、値が小さすぎた）ときも測り直す。
          // コールバックの中で高さを変えると「ResizeObserver loop completed with undelivered notifications」
          // のエラーになるので、次のフレームで測る。
          if (window.ResizeObserver) {
            var capRoQueued = false;
            new ResizeObserver(function () {
              var r = capBox.getBoundingClientRect();
              if (capRoQueued || (r.width === capW && r.height <= capMaxH + 0.5)) return;
              capRoQueued = true;
              window.requestAnimationFrame(function () {
                capRoQueued = false;
                measureStylistCap();
              });
            }).observe(capBox);
          }
        }
      }
      // Influencer: PC centered(中央強調 420×747+左右272×485), SP 等幅4枚 273×485 space 30
      var infEl = document.querySelector('.hair_oil_6 .influencer-slider.swiper');
      if (infEl) {
        ensureLoopSlides(infEl);
        var infSwiper = new Swiper(infEl, {
          effect: 'coverflow',
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
          loop: true,
          grabCursor: true,
          speed: 700,
          coverflowEffect: {
            rotate: 0,
            stretch: 40,
            depth: 0,
            scale: 0.648,
            modifier: 1,
            slideShadows: false
          },
          // 動画の長さで次へ送る（下の setupInfluencerVideos）。3秒の自動送りは使わない
          autoplay: false,
          navigation: {
            prevEl: '.hair_oil_6 .influencer-nav__prev',
            nextEl: '.hair_oil_6 .influencer-nav__next'
          }
        });
        setupInfluencerVideos(infEl, infSwiper);
      }
    }

    // ------------------------------------------------------------
    // 6-2) Influencer 動画スライドショー（9/25）
    //   ・中央スライドの動画だけを音声オフで自動再生し、再生が終わったら次のスライドへ送る
    //   ・左右のスライドは poster 表示のまま（preload="none" なので中央に来るまで読み込まない）
    //   ・音声ボタンで音あり／なしを切り替え、次の動画にも引き継ぐ
    //   ・セクションが画面外・タブ非表示のときは止める
    //   ・reduced-motion では自動再生せず、中央の動画をタップで再生／停止
    // ------------------------------------------------------------
    function setupInfluencerVideos(root, sw) {
      var soundOn = false;
      var inView = false;
      var videos = function () { return [].slice.call(root.querySelectorAll('.influencer-slider__video')); };
      var activeVideo = function () {
        var slide = sw.slides[sw.activeIndex];
        return slide ? slide.querySelector('.influencer-slider__video') : null;
      };
      var playActive = function (v) {
        if (v.preload !== 'auto') { v.preload = 'auto'; }
        var pr = v.play();
        if (pr && pr.catch) {
          pr.catch(function (err) {
            // 音ありの自動再生はブラウザに拒否されることがある → 音声オフに戻して再生し直す
            if (err && err.name === 'NotAllowedError' && !v.muted) {
              soundOn = false;
              v.muted = true;
              syncButtons();
              v.play().catch(function (e2) { console.warn('[KINUJO] influencer video play blocked:', e2 && e2.name); });
            } else if (!(err && err.name === 'AbortError')) {
              console.warn('[KINUJO] influencer video play failed:', err && err.name);
            }
          });
        }
      };
      var syncButtons = function () {
        root.querySelectorAll('.influencer-slider__sound').forEach(function (btn) {
          btn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          btn.setAttribute('aria-label', soundOn ? '音声をオフにする' : '音声をオンにする');
        });
      };
      var sync = function () {
        var act = activeVideo();
        videos().forEach(function (v) {
          if (v !== act && !v.paused) { v.pause(); }
        });
        syncButtons();
        if (!act) { return; }
        act.muted = !soundOn;
        if (inView && !reducedMotion && !document.hidden) { playActive(act); } else { act.pause(); }
      };
      sw.on('slideChangeTransitionStart', function () {
        var act = activeVideo();
        if (act) { act.currentTime = 0; }
        sync();
      });
      videos().forEach(function (v) {
        v.addEventListener('ended', function () {
          if (v === activeVideo()) { sw.slideNext(); }
        });
        // reduced-motion 時や自動再生が拒否された端末では、中央の動画のタップで再生／停止
        v.addEventListener('click', function () {
          if (v !== activeVideo()) { return; }
          if (v.paused) { playActive(v); } else { v.pause(); }
        });
      });
      root.querySelectorAll('.influencer-slider__sound').forEach(function (btn) {
        btn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          soundOn = !soundOn;
          var act = activeVideo();
          syncButtons();
          if (!act) { return; }
          act.muted = !soundOn;
          if (act.paused) { playActive(act); }
        });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.35 }).observe(root);
      } else {
        inView = true;
      }
      document.addEventListener('visibilitychange', sync);
      sync();
    }

    // ------------------------------------------------------------
    // 4) 商品特徴 point カード：SPのみ 1枚スライダー化
    //    （CSSスクロールスナップ＋JS生成の左右矢印＋3秒自動送り。
    //     PCはCSSで従来の縦積み表示のまま／矢印は非表示・自動送りなし）
    //    自動送りは：SP かつ画面内 かつ タブ表示中 かつ reduced-motion でない
    //    ときだけ動く。指で触れている間／VIEW MORE 展開中は止め、最後まで
    //    行ったら先頭へ戻る。
    // ------------------------------------------------------------
    (function () {
      var spMq = window.matchMedia(SP_QUERY);
      document.querySelectorAll('.hair_oil_10 .feat-rows').forEach(function (rows) {
        if (rows.dataset.sliderInit) { return; }
        var slides = [].slice.call(rows.children).filter(function (c) {
          return c.classList && c.classList.contains('feat-row');
        });
        if (slides.length < 2) { return; }
        rows.dataset.sliderInit = '1';

        // 矢印の絶対配置基準となるラッパーで .feat-rows を包む
        var outer = document.createElement('div');
        outer.className = 'feat-rows-outer';
        rows.parentNode.insertBefore(outer, rows);
        outer.appendChild(rows);

        var makeBtn = function (dir, label, d) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'feat-nav feat-nav--' + dir;
          b.setAttribute('aria-label', label);
          b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
          outer.appendChild(b);
          return b;
        };
        var prev = makeBtn('prev', '前の特徴へ', 'M15 5l-7 7 7 7');
        var next = makeBtn('next', '次の特徴へ', 'M9 5l7 7-7 7');

        // 「6つのフリー処方」（Multi）: SP ではスライダーの外（すぐ下）に移し、どのスライドでも表示する。
        // PC 幅に戻ったら元の位置（.feat-6way の末尾）へ戻す（9/25 kanae 様）
        var free = rows.querySelector('.feat-free');
        var freeHome = free ? free.parentNode : null;
        var placeFree = function () {
          if (!free) { return; }
          if (spMq.matches) {
            if (free.previousElementSibling !== outer) { outer.parentNode.insertBefore(free, outer.nextSibling); }
          } else if (free.parentNode !== freeHome) {
            freeHome.appendChild(free);
          }
        };
        placeFree();

        var idx = 0;
        // SP はスライダーの高さを表示中のスライドに合わせる（一番高いスライドに合わせると
        // 低いスライドの下に余白ができる：9/25 指摘）。PC は縦積みなので指定しない
        var fitHeight = function () {
          if (!spMq.matches) { rows.style.height = ''; return; }
          var s = slides[idx];
          if (s) { rows.style.height = s.offsetHeight + 'px'; }
        };
        var update = function () {
          prev.disabled = idx <= 0;
          next.disabled = idx >= slides.length - 1;
          fitHeight();
        };
        if ('ResizeObserver' in window) {
          new ResizeObserver(fitHeight).observe(rows.parentNode);
          slides.forEach(function (s) { new ResizeObserver(fitHeight).observe(s); });
        }
        if (spMq.addEventListener) {
          spMq.addEventListener('change', function () { placeFree(); fitHeight(); });
        }
        var go = function (i) {
          idx = Math.max(0, Math.min(slides.length - 1, i));
          rows.scrollTo({ left: idx * rows.clientWidth, behavior: 'smooth' });
          update();
        };
        prev.addEventListener('click', function () { go(idx - 1); restartAuto(); });
        next.addEventListener('click', function () { go(idx + 1); restartAuto(); });

        var ticking = false;
        rows.addEventListener('scroll', function () {
          if (ticking) { return; }
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var w = rows.clientWidth || 1;
            idx = Math.round(rows.scrollLeft / w);
            update();
          });
        }, { passive: true });

        update();

        // --- 3秒自動送り（SP のみ） ---
        var autoTimer = null;
        var inView = false;
        var touching = false;
        var stopAuto = function () {
          if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
        };
        var canAuto = function () {
          return !reducedMotion && spMq.matches && inView && !touching && !document.hidden &&
                 !rows.querySelector('.feat-row.is-open');
        };
        var startAuto = function () {
          stopAuto();
          if (!canAuto()) { return; }
          autoTimer = setInterval(function () {
            if (!canAuto()) { stopAuto(); return; }
            go(idx >= slides.length - 1 ? 0 : idx + 1);
          }, AUTOPLAY_DELAY);
        };
        var restartAuto = startAuto; // 手動操作後はカウントを頭から
        if (reducedMotion) { return; }

        rows.addEventListener('touchstart', function () { touching = true; stopAuto(); }, { passive: true });
        rows.addEventListener('touchend', function () { touching = false; startAuto(); }, { passive: true });
        rows.addEventListener('touchcancel', function () { touching = false; startAuto(); }, { passive: true });
        // VIEW MORE の開閉で再判定（開いている間は止める）
        rows.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.feat-row__more')) {
            window.setTimeout(startAuto, 0);
          }
        });
        document.addEventListener('visibilitychange', startAuto);
        if (spMq.addEventListener) { spMq.addEventListener('change', startAuto); }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            inView = entries[0].isIntersecting;
            startAuto();
          }, { threshold: 0.35 }).observe(outer);
        } else {
          inView = true;
          startAuto();
        }
      });
    })();

    // ------------------------------------------------------------
    // 5) hair_oil_3 商品カードのスタック演出 → JS 撤去（Phase B）
    //    旧実装は SP でスクロール中に .cards を position:fixed に切替え、
    //    getBoundingClientRect の実測から translate3d を手計算していた
    //    （画像遅延読込・フォント・iOS アドレスバーで高さが変わるとズレる、
    //     解放直後に Multi タブが一段ズレる：gap-report 注記4 / code-review 2-3）。
    //    PC・SP とも sec03-products.css の position:sticky（Figma 0:1467 の
    //    走路 1148px 間隔をそのまま CSS で再現）に統一した。JS は何もしない。
    // ------------------------------------------------------------

    // ------------------------------------------------------------
    // 6) Styling ギャラリー演出（参考: b-exgroup.com/orchidee の .p-index__gallery）
    //    HTML は変えず、写真ごとに2つの層をここで作る。
    //      .styling__pic（配置の基準。これ自体は動かさない）
    //        > .styling__image … パララックス。translateY を +distance% → -distance% へ
    //            > .styling__mask … ズーム＋ワイプ。scale 0.6 → 1 と mask-position ±100% → 0%
    //                > .styling__media > img
    //            > .styling__lbl … 縦書きラベル。写真と一緒に上下するが、ズーム・ワイプはかけない
    //    進捗はスクロール量ではなく「写真が表示域のどこにあるか」で決める（戻すと逆再生）。
    //    表示域は Multi の面（sticky の stage）の見えている範囲。面が留まっていないときは window。
    //      パララックス　: 写真上端が表示域の下端 → 写真下端が表示域の上端を抜ける、の全区間で 0 → 1
    //      ズーム＋ワイプ: 写真上端が表示域の下端 → 表示域の下から 20% の位置、の短い区間で 0 → 1
    //    参考サイトの GSAP scrub（パララックス 2 秒・マスク 1 秒）の遅れ追従を指数関数で再現する。
    //    rAF はスクロール中（写真が表示域の前後 1 画面以内のとき）と、値が目標に追いつくまでだけ回す。
    //    書き換えるのは transform と mask-position だけ（要素のサイズ・位置・余白は変えない）。
    //    reduced-motion 時は層だけ作って何もしない（移動なし・等倍・マスクなしの最終状態のまま）。
    // ------------------------------------------------------------
    (function () {
      var pics = document.querySelector('.hair_oil_10 .styling__pics');
      if (!pics) { return; }
      var picEls = pics.querySelectorAll('.styling__pic');
      if (picEls.length === 0) { return; }
      for (var c = 0; c < picEls.length; c++) {
        if (!picEls[c].querySelector('.styling__media')) { return; }
      }
      var section = document.querySelector('.hair_oil_10');
      var stage = pics.closest ? pics.closest('.feat-block__stage') : null;

      var photos = [];
      for (var i = 0; i < picEls.length; i++) {
        var el = picEls[i];
        var media = el.querySelector('.styling__media');
        var lbl = el.querySelector('.styling__lbl');
        var imageLayer = document.createElement('div');
        imageLayer.className = 'styling__image';
        var maskLayer = document.createElement('div');
        maskLayer.className = 'styling__mask';
        el.insertBefore(imageLayer, media);
        imageLayer.appendChild(maskLayer);
        maskLayer.appendChild(media);
        if (lbl) { imageLayer.appendChild(lbl); }
        photos.push({
          el: el, image: imageLayer, mask: maskLayer, distance: 0, from: 0,
          para: { value: 0, target: 0, lastTarget: 0, changedAt: 0 },
          reveal: { value: 0, target: 0, lastTarget: 0, changedAt: 0 },
          written: ['', '', '']
        });
      }
      if (reducedMotion) { return; }

      // 参考サイトの写真 a / b / c（distance −10 / +10 / +10、マスクの開始位置 −100% / +100% / −100%）を、
      // 画面上で上から順の3枚に割り当てる。PC と SP で並び順が違うので、配置（offsetTop）から毎フレーム決め直す
      // （WebKit は CSS 適用前にこのスクリプトが走ることがあり、初期化時の配置は当てにならない）。
      // mask-position −100% 始まりは右端から見え始めて境目が左へ、+100% 始まりは左端から見え始めて境目が右へ進む。
      var PRESETS = [
        { distance: -10, from: -100 },
        { distance: 10, from: 100 },
        { distance: 10, from: -100 }
      ];
      var assign = function () {
        var order = photos.slice().sort(function (a, b) {
          return (a.el.offsetTop - b.el.offsetTop) || (a.el.offsetLeft - b.el.offsetLeft);
        });
        for (var n = 0; n < order.length; n++) {
          order[n].distance = PRESETS[n % PRESETS.length].distance;
          order[n].from = PRESETS[n % PRESETS.length].from;
        }
      };

      var clamp01 = function (v) { return v < 0 ? 0 : (v > 1 ? 1 : v); };
      var viewRect = function () {
        var winH = window.innerHeight;
        if (stage && section && section.classList.contains('is-pin-stack')) {
          var s = stage.getBoundingClientRect();
          var top = Math.max(0, s.top);
          var bottom = Math.min(winH, s.bottom);
          // 面が画面の外にあるときは、面がある側の画面端に潰した表示域にする
          if (bottom < top) { top = bottom = (s.bottom <= 0 ? 0 : winH); }
          return { top: top, height: bottom - top };
        }
        return { top: 0, height: winH };
      };
      // 目標値を更新し、写真（動かさない pic の箱）と表示域の距離を返す（表示域に掛かっていれば 0）
      var measureTargets = function (p, view) {
        var r = p.el.getBoundingClientRect();
        var top = r.top - view.top;
        var vh = view.height;
        var span = vh + r.height;
        p.para.target = span > 0 ? clamp01((vh - top) / span) : (top < 0 ? 1 : 0);
        p.reveal.target = vh > 0 ? clamp01((vh - top) / (0.2 * vh)) : (top < 0 ? 1 : 0);
        return Math.max(0, top - vh, -(top + r.height));
      };

      // GSAP の scrub は「今の値 → 目標値」を scrub 秒の expo（残り 2^(-10t/scrub)）で追う。
      // 同じ減り方の指数関数で追従し、目標が変わらないまま scrub 秒たったら目標値に揃えて止める
      // （その時点の残りは最初の差の約 0.1%）。
      var SCRUB_PARA = 2000;
      var SCRUB_REVEAL = 1000;
      var follow = function (ch, scrubMs, now, dt) {
        if (Math.abs(ch.target - ch.lastTarget) > 1e-6) {
          ch.lastTarget = ch.target;
          ch.changedAt = now;
        }
        var gap = ch.target - ch.value;
        if (gap === 0) { return false; }
        if (Math.abs(gap) < 1e-4 || now - ch.changedAt >= scrubMs) {
          ch.value = ch.target;
          return false;
        }
        ch.value += gap * (1 - Math.exp(-dt * 10 * Math.LN2 / scrubMs));
        return true;
      };
      var render = function (p) {
        var y = p.distance * (1 - 2 * p.para.value);
        var s = 0.6 + 0.4 * p.reveal.value;
        var mx = p.from * (1 - p.reveal.value);
        var v0 = 'translateY(' + y.toFixed(3) + '%)';
        var v1 = 'scale(' + s.toFixed(4) + ')';
        var v2 = mx.toFixed(3) + '% 0%';
        if (v0 !== p.written[0]) { p.image.style.transform = v0; p.written[0] = v0; }
        if (v1 !== p.written[1]) { p.mask.style.transform = v1; p.written[1] = v1; }
        if (v2 !== p.written[2]) {
          p.mask.style.webkitMaskPosition = v2;
          p.mask.style.maskPosition = v2;
          p.written[2] = v2;
        }
      };

      var raf = 0;
      var lastTime = 0;
      var moving = false;
      // 直近に測った「写真と表示域の距離」の最小値と、そのときのスクロール位置。
      // スクロールのたびに位置を読む（レイアウト計算を起こす）代わりに、ここから今の距離を見積もる。
      var nearGap = 0;
      var gapScrollY = 0;
      var setMoving = function (on) {
        if (on === moving) { return; }
        moving = on;
        pics.classList.toggle('is-gallery-moving', on);
      };
      var galleryFrame = function (now) {
        raf = 0;
        if (syncInnerY) { syncInnerY(); }
        var dt = lastTime ? Math.min(now - lastTime, 100) : 1000 / 60;
        lastTime = now;
        var view = viewRect();
        var p;
        assign();
        nearGap = Infinity;
        for (var m = 0; m < photos.length; m++) { nearGap = Math.min(nearGap, measureTargets(photos[m], view)); }
        gapScrollY = window.pageYOffset;
        // 全部の写真が表示域から 1 画面より遠ければ見えないので、追従を待たずに目標値へ揃えて止める
        var far = nearGap > window.innerHeight;
        var busy = false;
        for (var n = 0; n < photos.length; n++) {
          p = photos[n];
          if (far) {
            p.para.value = p.para.target;
            p.reveal.value = p.reveal.target;
          }
          if (follow(p.para, SCRUB_PARA, now, dt)) { busy = true; }
          if (follow(p.reveal, SCRUB_REVEAL, now, dt)) { busy = true; }
          render(p);
        }
        setMoving(busy);
        if (busy) {
          raf = window.requestAnimationFrame(galleryFrame);
        } else {
          lastTime = 0;
        }
      };
      var requestGalleryFrame = function () {
        if (!raf) { raf = window.requestAnimationFrame(galleryFrame); }
      };

      // 初期表示：今の位置の値をそのまま置いてから（読み込み直後に動き出さない）、マスク等を有効にする
      assign();
      var initView = viewRect();
      var initNow = window.performance ? window.performance.now() : 0;
      nearGap = Infinity;
      gapScrollY = window.pageYOffset;
      for (var k = 0; k < photos.length; k++) {
        nearGap = Math.min(nearGap, measureTargets(photos[k], initView));
        photos[k].para.value = photos[k].para.target;
        photos[k].reveal.value = photos[k].reveal.target;
        follow(photos[k].para, SCRUB_PARA, initNow, 0);
        follow(photos[k].reveal, SCRUB_REVEAL, initNow, 0);
        render(photos[k]);
      }
      pics.classList.add('is-gallery-ready');

      // 写真が表示域の前後 1 画面以内にあり得るときだけフレームを回す。
      // 1回のスクロールで写真も表示域の端も最大でスクロール量と同じだけ動くので、距離の変化はその2倍以内。
      // （IntersectionObserver は面の overflow:clip で切られ、面の外にある写真の出入りを取りこぼすため使わない）
      window.addEventListener('scroll', function () {
        if (nearGap - 2 * Math.abs(window.pageYOffset - gapScrollY) <= window.innerHeight) { requestGalleryFrame(); }
      }, { passive: true });
      window.addEventListener('resize', requestGalleryFrame);
      window.addEventListener('load', requestGalleryFrame);
      if (window.ResizeObserver) {
        // VIEW MORE の開閉などで面の中身の高さが変わると、スクロールしなくても写真の位置が変わる
        var sizeRo = new ResizeObserver(requestGalleryFrame);
        var watched = stage ? stage.children : [pics];
        for (var w = 0; w < watched.length; w++) { sizeRo.observe(watched[w]); }
      }
    })();

    // ------------------------------------------------------------
    // 7) FAQ タブ切替（milk / oil / multi）
    // ------------------------------------------------------------
    document.querySelectorAll('.hair_oil_14 .faq__tab').forEach(function (t) {
      t.addEventListener('click', function () {
        var root = t.closest('.faq');
        root.querySelectorAll('.faq__tab').forEach(function (x) { x.classList.remove('is-active'); });
        root.querySelectorAll('.faq__panel').forEach(function (p) { p.classList.remove('is-active'); });
        t.classList.add('is-active');
        var panel = root.querySelector('.faq__panel[data-panel="' + t.dataset.tab + '"]');
        if (panel) { panel.classList.add('is-active'); }
      });
    });

    // ------------------------------------------------------------
    // 8) VIEW MORE 開閉（hair_oil_10 point 行）
    // ------------------------------------------------------------
    document.querySelectorAll('.hair_oil_10 .feat-row__more').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.feat-row');
        if (row && row.querySelector('.feat-row__detail')) { row.classList.toggle('is-open'); }
      });
    });

    // ------------------------------------------------------------
    // 9) 商品詳細アコーディオン：閉じる方向の高さアニメ
    //    details は open を外すと本文を即時に隠すため、本文を現在高→0へ
    //    350ms で縮めてから open を外す。reduced-motion 時は即時に閉じる。
    // ------------------------------------------------------------
    document.querySelectorAll('.hair_oil_7 .indi-card__acc-item').forEach(function (details) {
      var summary = details.querySelector('.indi-card__acc-summary');
      var body = details.querySelector('.indi-card__acc-body');
      var closingAnimation = null;
      if (!summary || !body) { return; }

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (!details.open) {
          body.style.removeProperty('height');
          details.open = true;
          return;
        }
        if (reducedMotion) {
          body.style.height = '0px';
          details.open = false;
          return;
        }
        if (closingAnimation) { return; }

        closingAnimation = body.animate(
          [{ height: body.getBoundingClientRect().height + 'px' }, { height: '0px' }],
          { duration: 350, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        closingAnimation.addEventListener('finish', function () {
          body.style.height = '0px';
          details.classList.add('is-closing');
          details.open = false;
          closingAnimation = null;
          window.requestAnimationFrame(function () {
            details.classList.remove('is-closing');
          });
        });
        closingAnimation.addEventListener('cancel', function () {
          closingAnimation = null;
        });
      });
    });

  });
})();
